import React, {useMemo} from 'react';
import {Layout} from '../layout';
import {
  getDatesForCalendar,
  getDatesGroupedByWeek,
  getWeekdayNames,
} from './functions';
import {DayHeader} from './DayHeader';
import {Day} from './Day';

type Props = {
  currentDate: Date;
  currentMonth: Date;
  size: number;
  onChange: (nextDate: Date) => void;
};

export const Days: React.FC<Props> = ({
  currentDate,
  currentMonth,
  size,
  onChange,
}) => {
  // Get dates and weekdates
  const weeks = useMemo(
    (): Date[][] => getDatesGroupedByWeek(getDatesForCalendar(currentMonth)),
    [currentMonth],
  );

  const weekdays = useMemo((): string[] => getWeekdayNames(), []);

  return (
    <Layout flex align="center" justify="flex-start" vertical>
      {/** Header */}
      <Layout>
        {weekdays.map(w => (
          <Layout key={w} width={size} height={size} centered>
            <DayHeader title={w} />
          </Layout>
        ))}
      </Layout>
      {/** Dates */}
      {weeks.map((week, index) => (
        <Layout key={index}>
          {week.map(date => (
            <Layout
              key={date.toDateString()}
              width={size}
              height={size}
              centered>
              <Day
                date={date}
                onSelected={onChange}
                currentDate={currentDate}
                currentMonth={currentMonth}
              />
            </Layout>
          ))}
        </Layout>
      ))}
    </Layout>
  );
};
